import { createStore } from "vuex";
import userTamboStore from "./userTamboStore.js";
import tambosStore from "./tambosStore.js";
import notificationStore from "./notificationStore";
import dietasStore from "./dietasStore.js";
import picadosStore from "./picadosStore.js";
import cosechasStore from "./cosechasStore.js";
import balanceadoStore from "./balanceadoStore.js";
import estadisticaStore from "./estadisticaStore.js";
import despachosStore from "./despachosStore.js";
import empresasStore from "./empresasStore.js";
import lotesStore from "./lotesStore.js";
import materialesStore from "./materialesStore.js";
import vacasStore from "./vacasStore.js";
import veterinarioStore from "./veterinarioStore.js";
import siembrasStore from "./siembrasStore.js";
import maquinariasStore from "./maquinariasStore.js";
import ordenesCompraStore from "./ordenesCompraStore.js";
import participantesStore from "./participantesStore.js";
import tareasStore from "./tareasStore.js";
import empleadosStore from "./empleadosStore.js";
import ventasStore from "./ventasStore.js";
import facturacionStore from "./facturacionStore.js";
import chequesStore from "./chequesStore.js";
import gastosTercerizadosStore from "./gastosTercerizadosStore.js";
import feedlotStore from "./feedlotStore.js";
import compraAnimalesStore from "./compraAnimalesStore.js";
import auditoriaStore from "./auditoriaStore.js";
import erpStore from "./erpStore.js";
import comprobantesStore from "./comprobantesStore.js";
import offlineStore from "./offlineStore.js";
import pasturasStore from "./pasturasStore.js";
import forrajesStore from "./forrajesStore.js";
import reservasGranoStore from "./reservasGranoStore.js";
import marketReferencesStore from "./marketReferencesStore.js";
import libroIvaStore from "./libroIvaStore.js";
import retencionesStore from "./retencionesStore.js";
import mapaAgrStore from "./mapaAgrStore.js";
import criaStore from "./criaStore.js";
import criaEficienciaStore from "./criaEficienciaStore.js";
import "material-design-icons-iconfont/dist/material-design-icons.css";

export default createStore({
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    clearAllStoresData({ commit, dispatch }) {
      console.log("🧹 Limpiando datos de todos los stores...");

      // Limpiar cada store que contenga datos del tambo
      commit("despachosStore/setState", []);
      commit("empresasStore/setState", []);

      // Limpiar participantes
      commit("participantesStore/clearState");

      // vacasStore
      commit("vacasStore/setState", []);
      commit("vacasStore/setAnimalesResumen", []);
      commit("vacasStore/setPendientesCambio", []);
      commit("vacasStore/setAnimalesVendidos", []);
      commit("vacasStore/setPaginacion", {
        total: 0,
        pagina_actual: 1,
        total_paginas: 1,
        limite: 15,
        siguiente_pagina: null,
        anterior_pagina: null,
      });
      commit("vacasStore/setPaginacionVendidos", {
        total: 0,
        pagina_actual: 1,
        total_paginas: 1,
        limite: 15,
        siguiente_pagina: null,
        anterior_pagina: null,
      });
      commit("vacasStore/setPaginacionPendientes", {
        total: 0,
        pagina_actual: 1,
        total_paginas: 1,
        limite: 10,
        siguiente_pagina: null,
        anterior_pagina: null,
      });

      commit("lotesStore/setState", []);
      commit("dietasStore/setState", []);
      commit("balanceadoCampoStore/setState", []);
      commit("balanceadoCompraStore/setState", []);

      // También limpiar errores y loading states
      commit("despachosStore/setError", null);
      commit("lotesStore/setError", null);
      commit("vacasStore/setError", null);
      commit("empresasStore/setError", null);
      commit("dietasStore/setError", null);
      commit("balanceadoCampoStore/setError", null);
      commit("balanceadoCompraStore/setError", null);

      console.log("✅ Datos limpiados correctamente");

      // Pasturas y forrajes
      try {
        commit("pasturasStore/clearState");
        commit("forrajesStore/clearState");
        commit("mapaAgrStore/setMapaCompleto", { tambo: null, lotes: [] });
        commit("mapaAgrStore/setLoteSeleccionado", null);
        commit("mapaAgrStore/setEstadoAgronomico", null);
      } catch (e) {
        // Silently ignore
      }

      // Feedlot stores
      try {
        commit("feedlotStore/clearState");
        commit("compraAnimalesStore/clearState");
        commit("auditoriaStore/clearState");
        commit("erpStore/clearState");
        commit("comprobantesStore/clearState");
      } catch (e) {
        // Silently ignore if stores don't have clearState
      }

      // Eficiencia de cría: cancela pedidos en vuelo, descarta respuestas tardías
      // y vacía la caché del establecimiento anterior.
      dispatch("criaEficienciaStore/reiniciar");
    },
  },
  modules: {
    userTamboStore,
    tambosStore,
    notificationStore,
    dietasStore,
    picadosStore,
    cosechasStore,
    estadisticaStore,
    balanceadoStore,
    despachosStore,
    empresasStore,
    lotesStore,
    materialesStore,
    vacasStore,
    veterinarioStore,
    siembrasStore,
    maquinariasStore,
    ordenesCompraStore,
    participantesStore,
    tareasStore,
    empleadosStore,
    ventasStore,
    facturacionStore,
    chequesStore,
    gastosTercerizadosStore,
    feedlotStore,
    compraAnimalesStore,
    auditoriaStore,
    erpStore,
    comprobantesStore,
    balanceadoCampoStore: balanceadoStore.balanceadoCampo,
    balanceadoCompraStore: balanceadoStore.balanceadoCompra,
    offlineStore,
    pasturasStore,
    forrajesStore,
    reservasGranoStore,
    marketReferencesStore,
    libroIvaStore,
    retencionesStore,
    mapaAgrStore,
    criaStore,
    criaEficienciaStore,
  },
});
